"use strict";

exports.__esModule = true;
exports.translateY = exports.translateX = exports.transitionEase = exports.transition = exports.transY = exports.transX = exports.toPx = exports.toPercentage = exports.marginTop = exports.marginRight = exports.marginLeft = exports.marginDir = exports.marginBottom = exports.mapStyles = exports.mapStyle = exports.fontSize = exports.defaultTransition = exports.colorFill = void 0;

var _ramda = require("ramda");

var _polished = require("polished");

var _variables = require("./variables");

// transition :: String -> String -> [String] -> [String]
var transition = (0, _ramda.curry)(function (ease, duration, properties) {
  return _polished.transitions.apply(void 0, properties.map(function (property) {
    return property + " " + duration + " " + ease;
  }));
}); // transitionEase :: String -> [String] -> [String]

exports.transition = transition;
var transitionEase = transition(_variables.defaultEase); // defaultTransition :: (String, ..., String) -> [String]

exports.transitionEase = transitionEase;

var defaultTransition = function defaultTransition() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return transitionEase("0.7s", properties);
}; // toPx :: String | Number -> String


exports.defaultTransition = defaultTransition;

var toPx = function toPx(num) {
  return num + "px";
}; // toPercentage :: String | Number -> String


exports.toPx = toPx;

var toPercentage = function toPercentage(num) {
  return num + "%";
}; // mapStyle :: String -> String | Number -> [String]


exports.toPercentage = toPercentage;
var mapStyle = (0, _ramda.curry)(function (property, value) {
  return property + ": " + value + ";";
}); // mapStyles :: [String] -> String | Number -> [String]

exports.mapStyle = mapStyle;
var mapStyles = (0, _ramda.curry)(function (properties, value) {
  return (0, _ramda.reduce)(function (accum, property) {
    return "\n      " + accum + "\n      " + mapStyle(property, value) + "\n    ";
  }, "", properties);
}); // colorFill: String -> String

exports.mapStyles = mapStyles;
var colorFill = mapStyles(["color", "fill"]); // fontSize :: String | Number -> String

exports.colorFill = colorFill;
var fontSize = mapStyle("font-size"); // transX :: String | Number -> String

exports.fontSize = fontSize;

var transX = function transX(val) {
  return "translate3d(" + val + ", 0, 0)";
};
/*
 *
 * transY :: String | Number -> String
 */


exports.transX = transX;

var transY = function transY(val) {
  return "translate3d(0, " + val + ", 0)";
}; // translateX :: String | Number -> [String]


exports.transY = transY;

var translateX = function translateX(val) {
  return mapStyle("transform", transX(val));
}; // translateY :: String | Number -> [String]


exports.translateX = translateX;

var translateY = function translateY(val) {
  return mapStyle("transform", transY(val));
}; // marginDir :: String -> String | Number -> [String]


exports.translateY = translateY;

var marginDir = function marginDir(dir) {
  return mapStyle("margin-" + dir);
}; // marginTop :: String | Number -> [String]


exports.marginDir = marginDir;
var marginTop = marginDir("top"); // marginBottom :: String | Number -> [String]

exports.marginTop = marginTop;
var marginBottom = marginDir("bottom"); // marginLeft :: String | Number -> [String]

exports.marginBottom = marginBottom;
var marginLeft = marginDir("left"); // marginRight :: String | Number -> [String]

exports.marginLeft = marginLeft;
var marginRight = marginDir("right");
exports.marginRight = marginRight;